export default __webpack_public_path__ + "static/media/img3.4a6bc4d2.png";